module.exports = __webpack_public_path__ + "img/51626497_L.b5f8530e.png";